function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 2");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-315.000000, -101.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(316.000000, 102.000000)"
}, React.createElement("path", {
  d: "M14.854838,13.5 L17.906018,16.55026 C18.279768,16.92401 18.281562,17.52776 17.9051196,17.905098 C17.5304726,18.278848 16.9240316,18.278848 16.5502816,17.9059964 L13.5000216,14.8548164 L10.4497616,17.9059964 C10.0760116,18.2797464 9.47226162,18.2815404 9.09492362,17.905098 C8.72117362,17.530451 8.72117362,16.92401 9.09402524,16.55026 L12.1452052,13.5 L9.09402524,10.44974 C8.72027524,10.07599 8.71848124,9.47224 9.09492362,9.094902 C9.46957062,8.721152 10.0760116,8.721152 10.4497616,9.09400362 L13.5000216,12.1451836 L16.5502816,9.09400362 C16.9240316,8.72025362 17.5277816,8.71845962 17.9051196,9.094902 C18.2788696,9.469549 18.2788696,10.07599 17.906018,10.44974 L14.854838,13.5 Z",
  fill: "#000000"
}), React.createElement("path", {
  d: "M13.5,27 C6.04449,27 0,20.95551 0,13.5 C0,6.04449 6.04449,0 13.5,0 C20.95551,0 27,6.04449 27,13.5 C27,20.95551 20.95551,27 13.5,27 Z",
  strokeOpacity: 0.101098121,
  stroke: "#000000"
}))));

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.2173eb00.svg";
export { ForwardRef as ReactComponent };